import { SET_PLACE, UPDATE_FAVOURITE } from '../actions/PlaceAction'

const defaultSate = {
    id       : null,
    isSet    : false,
    favourite: false,
    item     : null
};

const places = (state = defaultSate, action) => {
    let newState;

    switch (action.type)
    {
        case SET_PLACE:
            newState = {...state,
                id       : action.place.id,
                isSet    : true,
                item     : action.place,
                favourite: action.favourite
            };
            break;
        case UPDATE_FAVOURITE:
            newState = {...state,
                favourite: action.favourite
            };
            break;
        default:
            newState = state;
            break;
    }

    return newState;
};

export default places;


// WEBPACK FOOTER //
// ./src/reducers/PlaceReducer.js